module.exports = __webpack_public_path__ + "static/media/32_copper_metal_seamless.cb96666c.jpg";